import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyFoxMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#fff0e0" />
      <polygon points="200,600 397,300 594,600 500,700 294,700" fill="#d35400" />
      <g className="mode-copy" transform="translate(48,840)" fill="#321"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyFoxMode;
